export const TRACKING = {
	'data-tracking-id': 'pick-location'
};



// WEBPACK FOOTER //
// ../node_modules/@cube/location-widget/src/components/location-popover/constants.js